import TimeFormats, { LOCAL_TIME_PREFIX } from './TimeFormats';
import createD3TimeFormatter from './factories/createD3TimeFormatter';
import { removePrefix } from '../utils/prefix';
import FormatterRegistry from '../FormatterRegistry';
export default class TimeFormatterRegistry extends FormatterRegistry {
  constructor({
    defaultKey = TimeFormats.DATABASE_DATETIME,
    name = 'TimeFormatter',
    ...rest
  } = {}) {
    super({
      defaultKey,
      name,
      ...rest
    });
  } // eslint-disable-next-line class-methods-use-this


  createFormatter(format) {
    return createD3TimeFormatter({
      format: removePrefix(LOCAL_TIME_PREFIX, format),
      useLocalTime: format.startsWith(LOCAL_TIME_PREFIX)
    });
  }

}